/*
 * Copyright (c) 2025 [Bevatel Telecom Co.]. All Rights Reserved.
 *
 * This software and its documentation are the confidential and proprietary
 * information of [Bevatel Telecom Co.]. You shall not disclose such confidential
 * information and shall use it only in accordance with the terms of the
 * license agreement you entered into with [Bevatel Telecom Co.].
 */

import { createBv } from '@bv/plugins';
import './assets/sass/reset.scss';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import 'vue3-easy-data-table/dist/style.css';
import '@mdi/font/css/materialdesignicons.css';
import 'vue-multiselect/dist/vue-multiselect.css';
import { VsxIcon } from 'vue-iconsax';
import VueClickAway from 'vue3-click-away';
import VueObserveVisibility from 'vue3-observe-visibility';

import SharedBevaComponents from '@/components/SharedComponents';
import { mainRoute, modules } from '@/router';

import App from './App.vue';

import '@/assets/sass/_main.scss';

library.add(fas, fab, far);

const app = createApp(App);
app.component('font-awesome-icon', FontAwesomeIcon);
app.component('VsxIcon', VsxIcon);

// Pinia
const pinia = createPinia();
app.use(pinia);

// UI package
const bv = createBv({
  i18n: false,
  sip: false,
  mainRoute,
  sidebar: { modules },
  injectAuthRoutes: true,
});
app.use(bv);

app.use(VueObserveVisibility);
app.use(VueClickAway);
SharedBevaComponents.install(app);

app.mount('#app');
